.content-loader-container {
  padding: 16px;
  font-family: "Roboto", sans-serif;
}

.content-loader-header {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 16px;
}

.content-loader-flex {
  display: flex;
}

.content-loader-badge-item {
  padding-right: 5px;
}
